import React from "react";
import { FaClock } from "react-icons/fa";
import { DateDisplay } from "@components";

import { IconTag } from "./IconTag";

type IconTagTimeProps = {
  time: string | Date;
};

/**
 * An IconTag wrapper to display a time in a tag (rendered by default as a
 * locale string).
 * @param {string|Date|Timestamp} time Time being dislpayed.
 */
export function IconTagTime({ time, ...delegated }: IconTagTimeProps) {
  const date = typeof time == "string" ? new Date(time) : time;

  return (
    <IconTag icon={FaClock} text={<DateDisplay date={date} />} {...delegated} />
  );
}
